import React from 'react';

import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import { popupModel, PrivacySetting } from 'src/components/complex';

import { MCButton } from '../basic';
import AiAnalyse from './ai';
import analysesModel from 'src/pages/main/Analyses/analysesModel';
import ButtonDropdown from '../complex/ButtonDropdown';
import LANG_CONST from 'src/helpers/lang/const';
import config from 'src/config';
import { formatDuration, lang, scssVariables } from 'src/helpers';
import BaseComponent from '../BaseComponent';

export default class AnalyseItem extends BaseComponent {
  intervalId;
  copiedTimer = null;
  state = { copied: false };

  componentDidMount() {
    let { item } = this.props;
    this.intervalId = 'delete_analyse_' + item.id + '_' + Date.now();
    this.timer(() => {
      return this.expiredIn() > 0;
    }, this.intervalId);
  }

  componentWillUnmount() {
    this.clearTimer(this.intervalId);
    if (this.copiedTimer) clearTimeout(this.copiedTimer);
  }
  iconname = () => {
    let { item } = this.props;
    if (item.text?.toString().toLowerCase().indexOf('sugar') > -1) {
      return 'sugar-blood-level-icon';
    }
    if (item.text?.toString().toLowerCase().indexOf('x-ray') > -1) {
      return 'x-ray-icon';
    }
    return 'blood-tube-icon';
  };

  expiredIn = () => {
    let { item, auth } = this.props;
    if (auth?.isPatient) return 0;
    const expired = item.date + config.get('removeAnalysesTime');
    return (expired - Date.now()) / 1000;
  };

  render() {
    let {
      timeMessage,
      item,
      onPrivacySettings,
      privacySettingsData,
      onDelete,
      onEdit,
      showAi = true,
      auth
    } = this.props;
    let media = (item.media && item.media[0]) || null;
    const expiredIn = this.expiredIn();
    let showAction =
      !!onPrivacySettings ||
      (!!onDelete && (auth.isPatient || expiredIn > 0)) ||
      (!!onEdit && (auth.isPatient || expiredIn > 0));

    return (
      <div data-testid='analysis-item' className={'mc-list-item'} key={'mc-analyse-list-item-' + item.id}>
        {timeMessage && <div className={'mc-list-item-time'}>{timeMessage}</div>}
        <div className={'mc-list-item-content mc-flex-15 mc-p15 mc-wrap'}>
          <div className={'mc-icon-box'}>
            <SVGIcon iconname={this.iconname()} />
          </div>
          <div className={'mc-title mc-grow'}>{item.text}</div>
          {showAi && (
            <div className={'mc-flex-10 '}>
              <MCButton
                light
                primary
                radius
                medium
                label={LANG_CONST.buttons.ai_interpretation}
                onClick={() => {
                  console.log('show popup', item.id);
                  popupModel.setActivePopup('AI analysis interpretation', {
                    active: true,
                    component: AiAnalyse,
                    props: { model: analysesModel, analyseId: item.id }
                  });
                }}
              />
            </div>
          )}
          {media && (
            <div className={'mc-flex-10 '}>
              <MCButton
                light
                primary
                radius
                medium
                onClick={() => {
                  navigator.clipboard.writeText(media.uri).then(() => {
                    this.setState({ copied: true });
                    if (this.copiedTimer) clearTimeout(this.copiedTimer);
                    this.copiedTimer = setTimeout(() => this.setState({ copied: false }), 2000);
                  });
                }}
              >
                <SVGIcon
                  iconname={this.state.copied ? BASE_ICONS.CHECK : BASE_ICONS.LINK}
                  width={18}
                  height={18}
                  fill={scssVariables['colors-mc-primary']}
                />
                <span className={'mc-copy-btn-label'}>
                  <span className={'mc-copy-btn-label-spacer'}>
                    {lang.t(LANG_CONST.buttons.copy_link)}
                  </span>
                  <span className={'mc-copy-btn-label-text'}>
                    {lang.t(this.state.copied ? 'Copied!' : LANG_CONST.buttons.copy_link)}
                  </span>
                </span>
              </MCButton>
            </div>
          )}
          {media && (
            <div className={'mc-flex-10 '}>
              <MCButton
                type={'link'}
                light
                primary
                radius
                medium
                label={LANG_CONST.buttons.view}
                to={media.uri}
                target='_blank'
                rel='noreferrer'
              />
              <MCButton
                type={'download'}
                light
                primary
                radius
                medium
                label={LANG_CONST.buttons.download}
                to={media.uri}
                fileName={media.originalName}
                target='_blank'
                rel='noreferrer'
                download
              />
            </div>
          )}
          {showAction && (
            <ButtonDropdown
              menu={(hide) =>
                [
                  !!onPrivacySettings && (
                    <PrivacySetting
                      key={'privacy'}
                      title={LANG_CONST.titles.can_view_analyse}
                      placement={'bottom-start'}
                      label={lang.t(LANG_CONST.buttons.privacy)}
                      buttonProps={{ light: true, primary: true, radius: false }}
                      onChange={(privacySettings) => {
                        hide();
                        onPrivacySettings({ id: item.id, privacySettings });
                      }}
                      data={privacySettingsData}
                    />
                  ),
                  !!onEdit && (
                    <MCButton
                      key={'edit'}
                      type={'button'}
                      light
                      primary
                      style={{ width: '100%' }}
                      medium
                      onClick={() => {
                        hide();
                        onEdit(item);
                      }}
                    >
                      <span className={'mc-text-truncate'}>{lang.t(LANG_CONST.buttons.edit)}</span>
                      {expiredIn > 0 && (
                        <span className={'mc-text-truncate'} style={{ fontSize: 14 }}>
                          ({formatDuration(expiredIn)})
                        </span>
                      )}
                    </MCButton>
                  ),
                  !!onDelete && (
                    <MCButton
                      key={'delete'}
                      type={'button'}
                      light
                      quaternary
                      style={{ width: '100%' }}
                      medium
                      onClick={() => {
                        hide();
                        onDelete(item);
                      }}
                    >
                      <span className={'mc-text-truncate'}>
                        {lang.t(LANG_CONST.buttons.delete)}
                      </span>
                      {expiredIn > 0 && (
                        <span className={'mc-text-truncate'} style={{ fontSize: 14 }}>
                          ({formatDuration(expiredIn)})
                        </span>
                      )}
                    </MCButton>
                  )
                ].filter((a) => !!a)
              }
            />
          )}
        </div>
      </div>
    );
  }
}
